import React, { useContext, useRef, useState } from "react";
import { AvatarContext } from "../../../../contexts/AvatarContext/AvatarContextProvider";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import { uploadAvatarImages } from "../../../../Managers/Avatar";
import styles from "./index.module.scss";

function AvatarInitialScreen({ handleGenerateAvatar, handleCloseAvatar }) {
  const { userBasicDetails, user } = useContext(UserContext);
  const { handleScreen, addDetails, handleLoading } = useContext(AvatarContext);
  const [selectedImage, setSelectedImage] = useState(null);
  const [initialScreen, setInitialScreen] = useState(false);

  const handleClick1 = () => {
    if (userBasicDetails && userBasicDetails.avatar && !initialScreen) {
      if (userBasicDetails.avatar.key === "Avatar") {
        handleScreen("screen", "showAvatarScreen");
      } else {
        setInitialScreen(true);
        addDetails("cam_image", "");
      }
    } else {
      handleScreen("screen", "showCameraScreen");
    }
  };

  const handleChange = (event) => {
    // let url = URL.createObjectURL(event.target.files[0]);
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = async function () {
      let url_cam_image = await uploadAvatarImages(
        reader.result,
        "cam_image",
        user.uid,
        (res) => {}
      );
      setSelectedImage(event.target.files[0]);
      addDetails("cam_image", url_cam_image);
      handleScreen("screen", "showProfileScreen");
    };
  };

  const handleClick2 = () => {
    if (userBasicDetails && userBasicDetails.avatar && !initialScreen) {
      if (userBasicDetails.avatar.key === "Avatar") {
        setInitialScreen(true);
        addDetails("cam_image", "");
        // handleCloseAvatar();
      } else {
        handleGenerateAvatar();
      }
    } else {
      console.log(selectedImage);
    }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div>
        {" "}
        <input
          id="uploadCustomImage"
          style={{ visibility: "hidden", width: 0, height: 0 }}
          type="file"
          name="myImage"
          onChange={(event) => {
            console.log(event.target.files[0]);
            handleChange(event);
          }}
        />
      </div>

      {userBasicDetails && userBasicDetails.avatar ? (
        <img
          className={styles.avatarimg}
          src={
            userBasicDetails.avatar.key === "Avatar"
              ? userBasicDetails.avatar.avatar_face_img
              : userBasicDetails.avatar.cam_image
          }
          alt="avatarImg"
        />
      ) : (
        <div className={styles.profileInitials}>
          {`${userBasicDetails.firstName[0].toUpperCase()} ${userBasicDetails.lastName[0].toUpperCase()}`}
        </div>
      )}

      <div className={styles.btnsWrapper}>
        {userBasicDetails && userBasicDetails.avatar && !initialScreen ? (
          userBasicDetails.avatar.key === "Avatar" ? (
            <button onClick={handleClick1} className={`btn ${styles.btn}`}>
              Edit Avatar
            </button>
          ) : (
            // <label
            //   htmlFor={"uploadCustomImage"}
            //   className={`btn ${styles.btn}`}
            // >

            // </label>
            <button onClick={handleClick1} className={`btn ${styles.btn}`}>
              Replace
            </button>
          )
        ) : (
          <button onClick={handleClick1} className={`btn ${styles.btn}`}>
            Take a photo
          </button>
        )}

        {userBasicDetails && userBasicDetails.avatar && !initialScreen ? (
          userBasicDetails.avatar.key === "Avatar" ? (
            <button onClick={handleClick2} className={`btn ${styles.btn}`}>
              use Photo
            </button>
          ) : (
            // <label
            //   htmlFor={"uploadCustomImage"}
            //   style={{ height: "auto" }}
            //   className={`btn ${styles.btn}`}
            // >
            //   use Photo
            // </label>
            <button onClick={handleClick2} className={`btn ${styles.btn}`}>
              Generate Avatar
            </button>
          )
        ) : (
          <label
            htmlFor={"uploadCustomImage"}
            style={{ height: "auto" }}
            className={`btn ${styles.btn}`}
          >
            Upload Photo
          </label>
        )}
      </div>
    </div>
  );
}

export default AvatarInitialScreen;
